import React from "react";
import { Form, TreeSelect } from "antd";

export const __FormTreeSelect = ({ placeholder, fieldLabel, fieldName, ...props }) => {
    return (
        <Form.Item
            label={fieldLabel}
            name={fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
        >
            <TreeSelect
                placeholder={placeholder ? placeholder : typeof fieldLabel === "string" ? fieldLabel : ""}
                treeDefaultExpandAll
                allowClear={props.allowClear}
                treeData={props.treeData}
                disabled={props.disable}
                onSelect={(value, option) => props.onTreeSelectChange?.(value, option)}
                showSearch
                treeNodeFilterProp='title'
            />
        </Form.Item>
    )
}